<template>
  <div style="width: 100%; height: 100%" ref="mychart"></div>
</template>

<script>
import * as echarts from 'echarts'
export default {
  name: 'StackedColumn',
  props: {
    title: {
      type: String,
      default: ''
    },
    // xData: {
    //   type: Array,
    //   required: true
    // },
    // yData: {
    //   type: Array,
    //   required: true
    // },
    data: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    // yData() {
    //   this.initMyChart() // 重置图表
    // },
    // deep: true,
    // xData() {
    //   this.initMyChart() // 重置图表
    // }
    data() {
      this.initMyChart() // 重置图表
    }
  },
  data() {
    return {
      pieMyChart: null
    }
  },
  mounted() {
    // this.initMyChart()
    setTimeout(() => {
      this.initMyChart()
      const resizeOb = new ResizeObserver((entries) => {
        for (const entry of entries) {
          echarts.getInstanceByDom(entry.target).resize()
        }
      })
      resizeOb.observe(this.$refs.mychart)
    })
  },
  methods: {
    initMyChart() {
      let mychart = echarts.getInstanceByDom(this.$refs.mychart)
      if (mychart == null) mychart = echarts.init(this.$refs.mychart)
      this.pieMyChart = mychart

      let yAxisData = []
      let xAxisData = []
      // let myColor = ['#ff0000', '#ffff00', '#00b0f0', '#00b050']
      if (this.data) {
        yAxisData = this.data.stackedCommonData_y
        xAxisData = this.data.stackedCommonData_x
        //   .filter((el) => {
        //   el.name == '扣分'
        // })
        xAxisData[0].label = {
          show: true,
          position: 'right',
          formatter: '{c}'
        }
        console.log(this.data.stackedCommonData_x, '000000000')
      }
      const option = {
        title: {
          text: this.title,
          left: 'center',
          top: 15,
          textStyle: {
            fontSize: 14,
            fontWeight: 'normal'
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          //data: 每一项代表一个系列的name，如果没有指定会从当前系列中自动获取
          top: '10%',
          // type: 'scroll'
          textStyle: {
            color: '#aaa',
            fontSize: 12
          }
        },
        color: ['#7BC3E0', '#91CC75', '#FAC858', '#EE6666'],
        grid: {
          left: '2%',
          right: '5%',
          bottom: '3%',
          top: '8%',
          containLabel: true
        },
        xAxis: [
          {
            // type: 'category',
            // data: xAxisData,
            type: 'value' //度量轴数据，需series配置
          }
        ],
        yAxis: [
          {
            show: true,
            // type: 'category', //维度
            inverse: true,
            data: yAxisData,
            // axisLine: {
            //   show: false
            // },
            // splitLine: {
            //   show: false
            // },
            // axisTick: {
            //   show: false
            // },
            // axisLable: {
            //   // show: true,
            //   // width: 30,
            //   // rotate: 30,
            //   // interval: 0
            //   // textBorderColor: '#f9f9'
            // },
            axisLabel: {
              color: '#000',
              fontSize: 10,
              // formatter: function (value, index) {
              //   return [
              //     '{lg|' + (index + 1) + '}' + '{title|' + value + '} '
              //   ].join('\n')
              // },
              formatter: function (params) {
                var newParamsName = ''
                var paramsNameNumber = params.length
                var provideNumber = 30 //一行显示几个字
                var rowNumber = Math.ceil(paramsNameNumber / provideNumber)
                if (paramsNameNumber > provideNumber) {
                  for (var p = 0; p < rowNumber; p++) {
                    var tempStr = ''
                    var start = p * provideNumber
                    var end = start + provideNumber
                    if (p == rowNumber - 1) {
                      tempStr = params.substring(start, paramsNameNumber)
                    } else {
                      tempStr = params.substring(start, end) + '\n'
                    }
                    newParamsName += tempStr
                  }
                } else {
                  newParamsName = params
                }
                return newParamsName
              }
              // rich: {
              //   lg: {
              //     backgroundColor: '#339911',
              //     color: '#000',
              //     borderRadius: 15,
              //     // padding: 5,
              //     align: 'center',
              //     width: 15,
              //     height: 15
              //   }
              // }
            }
          }
        ],
        series: xAxisData
        // series: [
        //   // xAxisData,
        //   {
        //     type: 'bar' //柱状
        //     //     // 数据配置
        //     //     barMaxwidth: '20%',
        //     // data: xAxisData
        //     //     // stack: 'Ad',
        //     //     // name: this.topText
        //     //     // yAxisIndex: 2
        //   }
        // ]
      }
      mychart.setOption(option, true)
    }
  }
}
</script>
